import { Linkedin, Instagram } from "lucide-react";
const footerLinks = [{
  name: "Careers",
  href: "/careers"
}, {
  name: "Terms & Conditions",
  href: "/termsofuse"
}, {
  name: "Privacy Policy",
  href: "/privacy"
}, {
  name: "Contact Us",
  href: "/contact"
}];
export const Footer = () => {
  return <footer className="w-full border-t border-border bg-background">
      <div className="container mx-auto px-8 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Left: Copyright */}
          <p className="text-sm text-muted-foreground">
            © Copyright 2025 Shattara AI, Inc.
          </p>

          {/* Right: Links and Social Icons */}
          <div className="flex flex-wrap items-center justify-center gap-6">
            {/* Footer Links */}
            <div className="flex flex-wrap items-center justify-center gap-6">
              {footerLinks.map(link => <a key={link.name} href={link.href} className="text-sm text-foreground/70 hover:text-primary transition-colors cursor-pointer">
                  {link.name}
                </a>)}
            </div>

            {/* Social Icons */}
            <div className="flex items-center gap-2 ml-6">
              <a href="https://linkedin.com/company/shattaraai" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center h-9 w-9 rounded-md border border-border bg-background text-muted-foreground hover:bg-green/10 hover:text-green hover:border-green/20 transition-colors cursor-pointer" aria-label="LinkedIn">
                <Linkedin className="h-4 w-4" />
              </a>
              <a href="https://x.com/shattaraai" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center h-9 w-9 rounded-md border border-border bg-background text-muted-foreground hover:bg-green/10 hover:text-green hover:border-green/20 transition-colors cursor-pointer" aria-label="X">
                <svg className="h-4 w-4" fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932ZM17.61 20.644h2.039L6.486 3.24H4.298Z"/>
                </svg>
              </a>
              <a href="https://www.instagram.com/shattaraai/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center h-9 w-9 rounded-md border border-border bg-background text-muted-foreground hover:bg-green/10 hover:text-green hover:border-green/20 transition-colors cursor-pointer" aria-label="Instagram">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://www.tiktok.com/@shattaraai" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center h-9 w-9 rounded-md border border-border bg-background text-muted-foreground hover:bg-green/10 hover:text-green hover:border-green/20 transition-colors cursor-pointer" aria-label="TikTok">
                <svg className="h-4 w-4" fill="currentColor" role="img" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};